import React from "react"
import { I18n, Translate } from "utils/i18n-shim"
import {
  TableRow,
  Table,
  TableHead,
  TableCell,
  TableBody,
  Box,
  IconButton,
  Fab,
  Typography,
  Stack
} from "@mui/material"
import CloseIcon from "@mui/icons-material/Close"
import AddIcon from "@mui/icons-material/Add"
import { FieldArray } from "formik"
import { Field } from "formik"
import { TextField } from "shared/ui/berry-jass-formik"
import { TableBlankSlate } from "shared/ui/berry-jass"
import { createIntegrationParameter } from "../lib"

const FIELD_NAME = "integration_parameters_attributes"

export const IntegrationParameters = ({ formik }) => {
  const data = formik.values[FIELD_NAME].filter(({ _destroy }) => {
    return !_destroy
  })

  const showBlank = !data.length

  return (
    <FieldArray name={FIELD_NAME}>
      {(formHelpers) => {
        const handleAddIntegrationParameter = () => {
          formHelpers.push(createIntegrationParameter())
        }

        return (
          <Box>
            <Typography variant="h5">
              <Translate value="purchase-products.schalttool.parameters" />
            </Typography>
            <Table sx={{ tableLayout: "fixed", mt: 1.5 }} size="small">
              <TableHead>
                <TableRow>
                  <TableCell>
                    <Translate value="purchase-products.schalttool.name" />
                  </TableCell>
                  <TableCell>
                    <Translate value="purchase-products.schalttool.value" />
                  </TableCell>
                  <TableCell width="60px" />
                </TableRow>
              </TableHead>
              <TableBody>
                {data.map((parameter, index) => {
                  const handleDeleteIntegrationParameter = () => {
                    if (parameter.id) {
                      formik.setFieldValue(
                        `${FIELD_NAME}.${index}._destroy`,
                        true
                      )
                    } else {
                      formHelpers.remove(index)
                    }
                  }

                  return (
                    <TableRow
                      className={`integration-parameter-${index}`}
                      key={parameter.id ?? parameter.virtualId}
                    >
                      <TableCell>
                        <Field
                          fullWidth
                          name={`${FIELD_NAME}.${index}.name`}
                          placeholder={I18n.t(
                            "purchase-products.schalttool.name"
                          )}
                          component={TextField}
                        />
                      </TableCell>
                      <TableCell>
                        <Field
                          fullWidth
                          placeholder={I18n.t(
                            "purchase-products.schalttool.value"
                          )}
                          name={`${FIELD_NAME}.${index}.value`}
                          component={TextField}
                        />
                      </TableCell>
                      <TableCell>
                        <IconButton
                          title={I18n.t("actions.delete")}
                          onClick={handleDeleteIntegrationParameter}
                          size="large"
                        >
                          <CloseIcon />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  )
                })}
                {showBlank && (
                  <TableBlankSlate colSpan={3}>
                    <Stack sx={{ textAlign: "center" }}>
                      <Typography variant="h2" color="inherit">
                        <Translate value="integration-parameter.blank" />
                      </Typography>
                      <Typography color="inherit">
                        <Translate value="integration-parameter.add-placeholder" />
                      </Typography>
                    </Stack>
                  </TableBlankSlate>
                )}
              </TableBody>
            </Table>
            <Box marginTop="24px" display="flex" justifyContent="flex-end">
              <Fab
                size="small"
                color="primary"
                disabled={formik.isSubmitting}
                onClick={handleAddIntegrationParameter}
                title={I18n.t("add")}
              >
                <AddIcon sx={{ fontSize: 16 }} />
              </Fab>
            </Box>
          </Box>
        )
      }}
    </FieldArray>
  )
}
